define.alias("shared/components/shared/video-player/controls", "calendar/components/shared/video-player/controls");